import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "workflowtask",
  listKey: "tasks",
  itemKey: "task",
  getAll: types.GET_ALL_WORKFLOW_TASKS,
  getAllResponse: types.GET_ALL_WORKFLOW_TASKS_RESPONSE,
  getByIdResponse: types.GET_WORKFLOW_TASK_BY_ID_RESPONSE,
});
